import { ArtifactStatus } from '@yandex-360/telemost-sdk/models';

export type ConferenceHistoryItem = {
    sessionId: string;
    shortUrlId: string;
    meetingName?: string;
    startedAt: string;
    endedAt: string;
    summarizationStatus?: ArtifactStatus;
    cloudRecordingStatus?: ArtifactStatus;
    hasMeetingReport: boolean;
    hasLocalRecording: boolean;
};

export enum FETCHING_STATUS {
    IN_PROGRESS = 'in-progress',
    ERROR = 'error',
}
